/**
 * Mobile app-style pages (Categories, Offers) — no view-transition zoom,
 * header height sync, and overflow containment.
 */
(function () {
  if (!document.body.matches('.template-page-categories, .template-page-offers')) return;

  document.getElementById('view-transition-render-blocker')?.remove();

  window.addEventListener('pagereveal', (event) => {
    event.viewTransition?.skipTransition();
    if (window.matchMedia('(max-width: 749px)').matches) {
      window.scrollTo(0, 0);
    }
  });

  if (!window.matchMedia('(max-width: 749px)').matches) return;

  function recalcHeaderGroupHeight() {
    const header = document.querySelector('header-component');
    if (!(header instanceof HTMLElement)) return;

    const headerHeight = header.offsetHeight;
    document.body.style.setProperty('--header-height', `${headerHeight}px`);
    document.body.style.setProperty('--header-group-height', `${headerHeight}px`);
  }

  function scheduleRecalc() {
    window.requestAnimationFrame(recalcHeaderGroupHeight);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRecalc);
  } else {
    scheduleRecalc();
  }

  window.addEventListener('resize', scheduleRecalc, { passive: true });
})();
